import "./userinstructions.scss";
import { Link } from "react-router-dom";
import InstructionCarousel from "./instruction_carousel";

const UserInstructions = () => {
  const baPrivacyPolicy = "https://baai.co/privacy";

  return (
    <>
      <div className="container-fluid">
        <div className="row text-center">
          <div className="col-md-3"></div>
          <div className="col">
            <p id="modal-title">Quick Start Guide</p>
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="row text-center">
          <div className="col-md-3"></div>
          <div className="col">
            <p id="modal-sub-title">Follow the instructions below</p>
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="row text-center">
          <div className="col-md-3"></div>
          <div className="col">
            <p id="modal-sub-title">
              <InstructionCarousel />
            </p>
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="row text-center">
          {/* <div className='col-md-3'></div> */}
          <div className="col">
            <p id="modal-privacy-policy">
              We respect your privacy. We don’t share your personal data with
              any individual or <br /> organisation. Your data is safe with
              us.Our Privacy Policy
            </p>
          </div>
          {/* <div className='col-md-3'></div> */}
        </div>
        <div className="row text-center">
          <div className="col-md-3"></div>
          <div className="col">
            <Link to={baPrivacyPolicy} target="_blank">
              <p id="modal-privacy-policy">Privacy Policy</p>
            </Link>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
    </>
  );
};

export default UserInstructions;
